import { Notification } from "../types/notification";
export const scrollToErrorMessage = (
  ref?:
    | React.MutableRefObject<HTMLFormElement | null>
    | React.MutableRefObject<HTMLDivElement | null>,
  graphqlError?: Notification | null
): void => {
  if (graphqlError) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  let firstErrorFields: NodeListOf<Element>;

  if (ref?.current) {
    firstErrorFields = ref.current?.querySelectorAll(".error");
  } else {
    firstErrorFields = document?.querySelectorAll(".error");
  }

  const firstErrorField = firstErrorFields[0] as HTMLInputElement;
  if (firstErrorField) {
    // Use requestAnimationFrame to ensure focus and scroll happen after the next repaint
    requestAnimationFrame(() => {
      firstErrorField.focus();
      firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }
};
